"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChartWrapper = require("./ChartWrapper");
Object.keys(_ChartWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChartWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ChartWrapper[key];
    }
  });
});